import Splide from '@splidejs/splide';

export const RPMFirstFans = (function () {
	'use strict';

	let carousels;

	function init() {
		carousels = document.querySelectorAll('.rpmblock--firstfans');
		if (carousels.length > 0) {
			carousels.forEach((carousel) => {
				renderCarousel(carousel);
			});
		}
		console.log(carousels);
	}

	function renderCarousel(carousel) {
		// Find Slides, excluding clones
		let findSplide = carousel.querySelector('.splide');
		if (!findSplide) return;

		// Options
		let arrows = findSplide.dataset.carouselArrows == 1 ? true : false;
		let dots = findSplide.dataset.carouselDots == 1 ? true : false;

		// Render Splide
		let thisCarousel = new Splide(findSplide, {
			perPage  : 3,
			gap: '1.25rem',
			perMove: 3,
			type: 'loop',
			autoplay: true,
			arrows: false,
			pagination: false,
			dots: false,
			speed: 1250,
		});

		// Custom Pagination
		renderCustomPagination(thisCarousel, findSplide);

		// Additional Design
		thisCarousel.on('mounted', function () {
			applyModifications(findSplide);
		});

		// Mount the carousel
		thisCarousel.mount();
	}

	function applyModifications(carousel) {
		let pagination = carousel.querySelector('.splide__pagination');
		let arrows = carousel.querySelector('.splide__arrows');
		let image = carousel.querySelector('.rpmblock--carousel__slide-image');
		if (image && pagination) {
			arrows.style.paddingTop = image.offsetHeight + 'px';
			addEventListener('resize', (event) => {
				pagination = carousel.querySelector('.splide__pagination');
				arrows = carousel.querySelector('.splide__arrows');
				image = carousel.querySelector('.rpmblock--carousel__slide-image');
				arrows.style.paddingTop = image.offsetHeight + 'px';
			});
		}
	}

	function renderCustomPagination(carousel, target) {
		let findSlides = target.querySelectorAll('.splide__slide:not(.splide__slide--clone)');

		carousel.on('pagination:mounted', function (data) {
			// You can add your class to the UL element
			data.list.classList.add('splide__pagination--custom');
			// `items` contains all dot items
			data.items.forEach(function (item, idx) {
				// Search for first HEADING class to make the button text.
				let buttonText = findSlides[idx].querySelector('.heading') ? findSlides[idx].querySelector('.heading').textContent : '';
				item.button.textContent = String(buttonText);
			});
		});
	}

	return {
		init: init,
	};
})();
